import {PayloadAction, createSlice} from '@reduxjs/toolkit';
interface IEditImageProfile {
  imageFile: File | null;
  cropedImage: File | null;
}
interface IImage {
  imageFile: File | null;
}
const initialState: IEditImageProfile = {
  imageFile: null,
  cropedImage: null,
};
export const imageCropedit = createSlice({
  name: 'imageCropedit',

  initialState,
  reducers: {
    addingImage: (state, action: PayloadAction<IImage>) => {
      state.imageFile = action.payload.imageFile;
    },
    addingCropedImage: (state, action: PayloadAction<File>) => {
      state.cropedImage = action.payload;
    },
    clearImage: state => {
      state.imageFile = null;
    },
    clearAllData: state => {
      state.imageFile = null;
      state.cropedImage = null;
    },
  },
});
export const {addingImage, clearAllData, clearImage, addingCropedImage} =
  imageCropedit.actions;

export default imageCropedit.reducer;
